import {Component, Input, OnInit} from '@angular/core';
import {BrowseConfig} from '@core/bean/browse-config';
import {Pagination} from '@core/bean/pagination';
import {HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CommonsService} from '@core/service/commons.service';
import {NzModalService} from 'ng-zorro-antd';
import {ClaimDtService} from '../../../../routes/jy-srm/contract-order-execute/claim-management/claim-dt.service';

@Component({
  selector: 'app-claim-dt',
  templateUrl: './claim-dt.component.html',
  styles: []
})
export class ClaimDtComponent implements OnInit {

                          // ClaimDtBrowseComponent
  static componentName = 'ClaimDtBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  formLoading = false;
  pagination: Pagination = new Pagination();
  searchData: any = {};

  constructor(private commonsService: CommonsService,
              private modalService: NzModalService,
              private claimDtService: ClaimDtService
  ) {
    this.pagination.getData = function (params: HttpParams): Observable<any> {
      return claimDtService.query(params);
    }
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

}
